import React from 'react';
import { Loader } from 'commons-ui';

import usePriorityList from './usePriorityList';
import { styles } from './updatePriorityList.style';
import PriorityTags from './PriorityListTags';
import * as dashboardModel from '../../utils/model';

const UpdatePriorityList: React.FC<{}> = () => {
	const { segmentLists, submitSegmentPriority, segmentInputText, handleInputChange, showLoader } = usePriorityList();
	return (
		<div style={styles.mainContainer}>
			{showLoader && <Loader />}
			<div style={styles.priorityList}>
				<h2>User CTD Payout Segments</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.userCtdPayoutSegments]} />
			</div>
			<div style={styles.priorityList}>
				<h2>CTD User Segment Offer Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.ctdUserSegmentPriorityList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.ctdUserSegmentPriorityList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.ctdUserSegmentPriorityList}
						onChange={handleInputChange}
						placeholder='Enter user ctd payout segment'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.ctdUserSegmentPriorityList)}
						style={styles.button}>
						Update CTD User Segment Offer Priority List
					</button>
				</div>
			</div>
			<h1 style={styles.mainHeading}> Conversion Config Priorities</h1>
			<br />
			<div style={styles.priorityList}>
				<h2>Withdraw Fees Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.withdrawFeeSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.withdrawFeeSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.withdrawFeeSegmentList}
						onChange={handleInputChange}
						placeholder='Enter withdraw fees segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.withdrawFeeSegmentList)}
						style={styles.button}>
						Update Withdraw Fees Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>CTD Amount Limit Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.ctdAmountLimitSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.ctdAmountLimitSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.ctdAmountLimitSegmentList}
						onChange={handleInputChange}
						placeholder='Enter ctd amount limit segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.ctdAmountLimitSegmentList)}
						style={styles.button}>
						Update CTD Amount Limit Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>Payout Amount Limit Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.payoutAmountLimitSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.payoutAmountLimitSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.payoutAmountLimitSegmentList}
						onChange={handleInputChange}
						placeholder='Enter payout amount limit segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.payoutAmountLimitSegmentList)}
						style={styles.button}>
						Update Payout Amount Limit Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>Cool Off Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.coolOffSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.coolOffSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.coolOffSegmentList}
						onChange={handleInputChange}
						placeholder='Enter cool off segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.coolOffSegmentList)}
						style={styles.button}>
						Update Cool Off Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>CTD Cool Off Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.ctdCoolOffSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.ctdCoolOffSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.ctdCoolOffSegmentList}
						onChange={handleInputChange}
						placeholder='Enter ctd cool off segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.ctdCoolOffSegmentList)}
						style={styles.button}>
						Update CTD Cool Off Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>Payout Cool Off Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.payoutCoolOffSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.payoutCoolOffSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.payoutCoolOffSegmentList}
						onChange={handleInputChange}
						placeholder='Enter payout cool off segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.payoutCoolOffSegmentList)}
						style={styles.button}>
						Update Payout Cool Off Segment Priority List
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>Leave Intent Segment Priority List</h2>
				<PriorityTags priorities={segmentLists[dashboardModel.ESupportedCTDConfigPriority.leaveIntentSegmentList]} />
				<div style={styles.updateSection}>
					<textarea
						value={segmentInputText[dashboardModel.ESupportedCTDConfigPriority.leaveIntentSegmentList]}
						style={styles.textarea}
						rows='5'
						name={dashboardModel.ESupportedCTDConfigPriority.leaveIntentSegmentList}
						onChange={handleInputChange}
						placeholder='Enter payout cool off segment list'
					/>
					<button
						type='button'
						onClick={() => submitSegmentPriority(dashboardModel.ESupportedCTDConfigPriority.leaveIntentSegmentList)}
						style={styles.button}>
						Update Leave Intent Segment Priority List
					</button>
				</div>
			</div>
		</div>
	);
};
export default UpdatePriorityList;
